<template>
  <div>
    <img v-if="winnerImg != ''" :src="winnerImg" width="100%">
    <img v-if="winnerImg == ''" src="../assets/img/foundwinner.png" width="100%">
    <div class="wrap">
      <div class="winner_title">
        <el-row>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(1)">
              <div class="winner_flag">
                
                <img
                  v-if="activeTab === 1"
                  :src=winnerLogos.pc_winner_logo_1_active
                  style="height: 60px"
                />
                <img
                  v-else
                  :src="winnerLogos.pc_winner_logo_1_inactive"
                  style="height: 60px"
                />
                <!-- <h5 class="title-active">短线宝</h5> -->
                <div class="title_content">
                  <p :class="
                      activeTab === 1 ? 'title-active' : 'title-inactive'
                    ">{{ $t('foundWinner.smspackage') }}</p>
                  <p
                    :class="activeTab === 1 ? 'title-active' : 'title-inactive'"
                  >
                    2796 {{ $t('foundWinner.yuanYear') }}
                  </p>
                  <p
                    :class="
                      activeTab === 1 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.dailySelectionPotentialStock') }}
                  </p>
                  <p
                    :class="
                      activeTab === 1 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.signToRead') }}
                  </p>
                </div>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(2)">
              <div class="winner_flag">
                <img
                  v-if="activeTab === 2"
                  :src=winnerLogos.pc_winner_logo_2_active
                  style="height: 60px"
                />
                <img
                  v-else
                  :src=winnerLogos.pc_winner_logo_2_inactive
                  style="height: 60px"
                />
                <!-- <h5>牛人牛股</h5> -->
                <div class="title_content">
                  <p :class="
                      activeTab === 2 ? 'title-active' : 'title-inactive'
                    ">{{ $t('foundWinner.bullstock') }}</p>
                  <p
                    :class="activeTab === 2 ? 'title-active' : 'title-inactive'"
                  >
                    3600{{ $t('foundWinner.yuanYear') }}
                  </p>
                  <p
                    :class="
                      activeTab === 2 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.bigDataStock') }}
                  </p>
                  <p
                    :class="
                      activeTab === 2 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.signToRead') }}
                  </p>
                </div>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(3)">
              <div class="winner_flag">
                <img
                  v-if="activeTab === 3"
                  :src=winnerLogos.pc_winner_logo_3_active
                  style="height: 60px"
                />
                <img
                  v-else
                  :src=winnerLogos.pc_winner_logo_3_inactive
                  style="height: 60px"
                />
                <!-- <h5>问财神</h5> -->
                <div class="title_content">
                  <p :class="
                      activeTab === 3 ? 'title-active' : 'title-inactive'
                    ">{{ $t('foundWinner.godofwealth') }}</p>
                  <p
                    :class="activeTab === 3 ? 'title-active' : 'title-inactive'"
                  >
                    3456{{ $t('foundWinner.yuanYear') }}
                  </p>
                  <p
                    :class="
                      activeTab === 3 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.goldInvestHotStock') }}
                  </p>
                  <p
                    :class="
                      activeTab === 3 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.signToRead') }}
                  </p>
                </div>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0);" @click="getCode(4)">
              <div class="winner_flag">
                <img
                  v-if="activeTab === 4"
                  :src=winnerLogos.pc_winner_logo_4_active
                  style="height: 60px"
                />
                <img
                  v-else
                  :src=winnerLogos.pc_winner_logo_4_inactive
                  style="height: 60px"
                />
                <!-- <h5>尾盘追击</h5> -->
                <div class="title_content">
                  <p :class="
                      activeTab === 4 ? 'title-active' : 'title-inactive'
                    ">{{ $t('foundWinner.lastchasing') }}</p>
                  <p
                    :class="activeTab === 4 ? 'title-active' : 'title-inactive'"
                  >
                    7188{{ $t('foundWinner.yuanYear') }}
                  </p>
                  <p
                    :class="
                      activeTab === 4 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.pickOfDay') }}
                  </p>
                  <p
                    :class="
                      activeTab === 4 ? 'subtitle-active' : 'subtitle-inactive'
                    "
                  >
                  {{ $t('foundWinner.signToRead') }}
                  </p>
                </div>
              </div>
            </a>
          </el-col>
        </el-row>
      </div>
      <div class="found_winner">
        <!-- <hr class="gray_line" /> -->
        <div class="stock_list" style="min-height: 300px">
          <el-row>
            <el-col :span="6">
              <div><p class="stock">{{ $t('foundWinner.latestStockPool') }}</p></div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="more">
                <el-button type="text" @click="isLogin('stock_today')"
                  ><span>{{ $t('foundWinner.more') }}</span></el-button
                >
              </div>
            </el-col>
          </el-row>
          <div class="found_winner_title">
            <el-row>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.stockName') }}</div>
              </el-col>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.attentionToPrice') }}</div>
              </el-col>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.highestPrice') }}</div>
              </el-col>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.biggestIncrease') }}</div>
              </el-col>
            </el-row>
          </div>
          <div
            class="found_winner_list"
            v-for="(item, index) in stock_today.slice(0, 3)"
            :key="index"
          >
            <el-row>
              <el-col :span="6">
                <router-link
                  :to="{
                    name: 'Stockdetailed',
                    query: { symbol: item.stock_code },
                  }"
                >
                  <div class="stock_name">
                    <span v-if="$store.state.loginType"
                      >{{ item.stock_name }} / &nbsp;</span
                    >
                    <span v-if="$store.state.loginType">{{
                      item.stock_code
                    }}</span>
                    <router-link
                      to="/login"
                      v-else
                      style="color: black"
                    >
                      <p>{{ $t('foundWinner.registerLoginReadable') }}</p>
                    </router-link>
                  </div>
                </router-link>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <span>{{ item.focus_price }} /&nbsp;</span>
                  <span>{{ item.focus_time }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <span>{{ item.high_price }} /&nbsp;</span>
                  <span>{{ item.high_time }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details red" v-if="item.stock_status != 1">
                  {{ (Number(item.changepercent) * 100).toFixed(2) }}%
                </div>
                <div class="stock_details red" v-else>- -</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- <hr class="gray_line" /> -->
        <br />
        <div class="stock_list">
          <el-row>
            <el-col :span="6">
              <div class="stock">{{ $t('foundWinner.recentFifteenDayIncreaseList') }}</div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="more">
                <el-button type="text" @click="isLogin('stock_history')"
                  ><span>{{ $t('foundWinner.more') }}</span></el-button
                >
              </div>
            </el-col>
          </el-row>
          <div class="found_winner_title">
            <el-row>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.stockName') }}</div>
              </el-col>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.attentionToPrice') }}</div>
              </el-col>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.highestPrice') }}</div>
              </el-col>
              <el-col :span="6">
                <div style="color: #899199; font-size: 14px">{{ $t('foundWinner.biggestIncrease') }}</div>
              </el-col>
            </el-row>
          </div>
          <div
            class="found_winner_list"
            v-for="(item, index) in stock_history.slice(0, 5)"
            :key="index"
          >
            <el-row>
              <el-col :span="6">
                <div class="stock_name">
                  <router-link
                  :to="{
                    name: 'Stockdetailed',
                    query: { symbol: item.stock_code },
                  }"
                >
                  <div class="stock_name">
                    <span v-if="$store.state.loginType"
                      >{{ item.stock_name }} / &nbsp;</span
                    >
                    <span v-if="$store.state.loginType">{{
                      item.stock_code
                    }}</span>
                    <router-link
                      to="/login"
                      v-else
                      style="color: black"
                    >
                      <p>{{ $t('foundwinner.registerLoginReadable') }}</p>
                    </router-link>
                  </div>
                </router-link>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <p>{{ item.focus_price }} /&nbsp;</p>
                  <p>{{ item.focus_time }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details">
                  <p>{{ item.high_price }} /&nbsp;</p>
                  <p>{{ item.high_time }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="stock_details red" v-if="item.stock_status != 1">
                  {{ (Number(item.changepercent) * 100).toFixed(2) }}%
                </div>
                <div class="stock_details red" v-else>- -</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <el-dialog
        :title="$t('foundwinner.laststock')"
        :visible.sync="stock_today_status"
        width="1000px"
      >
        <el-table :data="stock_today" style="width: 100%">
          <el-table-column prop="stock_name" align="center" :label="$t('foundWinner.name')">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol: scope.row.stock_code },
                }"
                ><span style="color: black">{{
                  scope.row.stock_name
                }}</span></router-link
              >
            </template>
          </el-table-column>
          <el-table-column prop="stock_code" align="center" :label="$t('foundWinner.code')">
          </el-table-column>
          <el-table-column prop="focus_price" align="center" :label="$t('foundWinner.attentionToPrice')">
          </el-table-column>
          <el-table-column prop="focus_time" align="center" :label="$t('foundWinner.attentionTime')">
          </el-table-column>
          <el-table-column prop="high_price" align="center" :label="$t('foundWinner.highestPrice')">
          </el-table-column>
          <el-table-column prop="high_time" align="center" :label="$t('foundWinner.highestTime')">
          </el-table-column>
          <el-table-column align="center" :label="$t('foundWinner.biggestIncrease')">
            <template slot-scope="scope">
              <span v-if="scope.row.stock_status != 1"
                >{{ (Number(scope.row.changepercent) * 100).toFixed(2) }}%</span
              >
              <span v-else>- -</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="stock_today_status = false"
            style="background-color: var(--baseColor); color: #ffffff"
            >{{ $t('foundwinner.sure') }}</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :title="$t('foundWinner.recentFifteenDayIncreaseList')"
        :visible.sync="stock_history_status"
        width="1000px"
      >
        <el-table :data="stock_history" style="width: 100%">
          <el-table-column prop="stock_name" align="center" :label="$t('foundWinner.name')">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol: scope.row.stock_code },
                }"
                ><span style="color: black">{{
                  scope.row.stock_name
                }}</span></router-link
              >
            </template>
          </el-table-column>
          <el-table-column prop="stock_code" align="center" :label="$t('foundWinner.code')">
          </el-table-column>
          <el-table-column prop="focus_price" align="center" :label="$t('foundWinner.attentionToPrice')">
          </el-table-column>
          <el-table-column prop="focus_time" align="center" :label="$t('foundWinner.attentionTime')">
          </el-table-column>
          <el-table-column prop="high_price" align="center" :label="$t('foundWinner.highestPrice')">
          </el-table-column>
          <el-table-column prop="high_time" align="center" :label="$t('foundWinner.highestTime')">
          </el-table-column>
          <el-table-column align="center" :label="$t('foundWinner.biggestIncrease')">
            <template slot-scope="scope">
              <span v-if="scope.row.stock_status != 1"
                >{{ (Number(scope.row.changepercent) * 100).toFixed(2) }}%</span
              >
              <span v-else>- -</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="stock_history_status = false"
            style="background-color: var(--baseColor); color: #ffffff"
            >{{ $t('rechargeau.sure') }}</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: "FoundWinners",
  data() {
    return {
      stock_today: [],
      stock_today_status: false,
      stock_history: [],
      stock_history_status: false,
      activeColor: "red",
      winnerImg: "",
      activeTab: 1,
      winnerLogos:{}

    };
  },
  methods: {
    getWinnerImage() {
      let that = this;
      let loadingInstance = Loading.service({ fullscreen: true });
      that
        .$http({
          url: "/app/FoundWinners/logos",
          method: "post",
          data: {},
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.winnerLogos = res.data.data;
            loadingInstance.close();
          } 
        }).catch(function (e) {
          loadingInstance.close();
        });
    },
    getCode(classify) {
      let that = this;
      this.activeTab = classify;
      that
        .$http({
          url: "/app/FoundWinners/found_winner", //请求地址
          method: "post",
          data: {
            action: "found_winner",
            classify: classify,
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.status === 200) {
            let data = resData.data;
            let stock_today = [];
            let stock_history = [];
            for (let i = 0, len = data.length; i < len; i++) {
              switch (data[i].status) {
                case 0:
                  stock_history.push(data[i]);
                  break;
                case 1:
                  stock_today.push(data[i]);
                  break;
              }
            }
            that.stock_today = stock_today;
            that.stock_history = stock_history;
          } else {
          }
        });
    },
    isLogin(type) {
      let that = this;
      if (this.$store.state.loginType) {
        switch (type) {
          case "stock_today":
            that.stock_today_status = true;
            break;
          case "stock_history":
            that.stock_history_status = true;
            break;
        }
      } else {
        that.$message({
          message: that.$t('foundWinner.notLoggedIn'),
          type: "error",
          onClose: function () {
            that.$router.push({
              path: "/login",
            });
          },
        });
      }
    },
    winnerConfig() {

      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: 'foundwinner_banner'
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          that.winnerImg = res.data.data;
        });
    },
  },
  mounted: function () {
    let that = this;
    that.getCode(1);
    that.getWinnerImage();
    that.winnerConfig();
  },
  beforeDestroy() {
    clearInterval(this.chatTimer);
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: max-content;
  background-size: cover;
  overflow: hidden;
  background-position: 50%;
  position: relative;
  background-color: #fff;
  /* padding-top: 20px !important; */
  padding-bottom: 30px;
  background-color: #f4f4f8;
}

.gray_line {
  border-color: #ffffff87;
  margin-bottom: 30px;
}

.winner_title {
  width: 100vw;
  margin: 0 auto;
  padding: 30px 100px;
  background-color: #ffffff;
}

.winner_flag {
  text-align: center;
}
.winner_flag h5 {
  color: black;
  margin-top: 10px;
}
.winner_flag {
  /* height: 80px; */
}

.found_winner {
  position: static;
  width: 1200px;
  padding: 10px 40px 50px;
  /* background-color: #fff; */
  margin: auto;
  margin-top: 30px;
  border-radius: 15px;
}

.stock_list {
  margin-bottom: 30px;
  background-color: #ffffff;
  border-radius: 15px;
  padding: 30px;
}

.title_content {
  background: white;
  width: 192px;
  height: 100px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 5px;
  transition: height 0.4s;
  -moz-transition: height 0.4s; /* Firefox 4 */
  -webkit-transition: height 0.4s; /* Safari and Chrome */
  -o-transition: height 0.4s; /* Opera */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #333;
  /* margin-top: 20px; */
}

.title_content:hover {
}

.found_winner_title {
  width: 100%;
  margin: 30px auto 0px;
  padding-left: 30px;
}

.found_winner_title h4 {
  text-align: center;
  font-size: 16px;
  color: #899199;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.found_winner_list {
  /* background: rgb(235, 235, 235); */
  height: 30px;
  /* border-radius: 50px; */
  margin-top: 20px;
  padding-left: 30px;
  /* -moz-box-shadow: 5px 5px 5px #999; 老的 Firefox */
  /* box-shadow: 3px 3px 5px #999; */
}

.stock_name {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  height: 30px;
  text-align: left;
  /* background: rgb(246, 56, 56); */
  /* border-radius: 50px; */
  color: var(--baseColor);
  /* font-weight: bold; */
  font-size: 12px;
  display: flex;
  /* padding-left: 30px; */
  /* align-items: center; */
  /* justify-content: center; */
  /* flex-direction: column; */
}
.stock {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  /* text-align: center; */
  font-size: 16px;
  /* display: flex; */
  /* align-items: center; */
  /* flex-direction: column; */
  line-height: 50px;
  font-weight: 600;
}
.more span {
  font-size: 16px;
  color: var(--baseColor);
}
.stock_details {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  /* text-align: center; */
  height: 30px;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  /* padding-left: 20px; */
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  /* flex-direction: column; */
}

.red {
  color: red;
}

.more {
  line-height: 50px;
  text-align: right;
}
.stockPopup {
  width: 90%;
}
.title-active {
  color: var(--baseColor) !important;
  font-size: 20px;
  font-weight: 600;
}
.subtitle-active {
  color: var(--baseColor) !important;
}
.title-inactive {
  color: #000 !important;
  font-size: 20px;
  font-weight: 600;
}
.subtitle-inactive {
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FoundWinners.vue